@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.shopify-invalid-content {
  margin-top: 10px;
  border: 1px solid @settings-page--stores-selected-checkout-shopify-invalid--border-color;
  padding: 100px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.5;

  P {
    font-size: 16px;
  }
  ul {
    text-align: left;
    list-style: inside;
    .item {
      display: list-item;
    }
  }
}
